import {
    GET_MODEMS_REQUEST,
    GET_MODEMS_SUCCESS,
    GET_MODEMS_FAILURE,
    ADD_PREVIEW_MODEMS,
    POST_MODEMS_SUCCESS,
    REMOVE_PREVIEW_MODEMS
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: [],
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_MODEMS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_MODEMS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.accmodems,
                isInitialFetch: false,
            };
        case GET_MODEMS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
            case ADD_PREVIEW_MODEMS:
                {
                    const newModems = action.payload.accmodems.map((d) => ({...d, isDisabled: true})); 
            return {
                ...state,
                data: [...newModems, ...state.data],
            };
        }

        case REMOVE_PREVIEW_MODEMS: {
            return {
                ...state,
                data: state.data.filter((f) => !f.isDisabled),
            };
        }
            case POST_MODEMS_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    data: action.payload.accmodems,
                    isInitialFetch: false,
                };
        default:
            return state;
    }
};